import { createConfirmation } from "react-confirm";
import MultiPrintDialog from "./MultiPrintDialog";

export const showMultiPrintDialog = createConfirmation(MultiPrintDialog);
